import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PatientCenterCard = _resolveComponent("PatientCenterCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enabledCenters, (center) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-sm-6 col-md-6 col-lg-6 col-xxxl-4 mb-25",
        key: center.id
      }, [
        _createVNode(_component_PatientCenterCard, { center: center }, null, 8 /* PROPS */, ["center"])
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}